<template>
  <div class="login-shell">
    <div class="row login-container">
      <!-- Logo section for mobile view -->
      <div class="col-12 d-md-none mobile-logo text-center">
        <img src="../../../assets/unodc-logo-white.png" class="img-fluid mobile-logo-img mt-2" />
      </div>

      <!-- Left section with background image -->
      <div
        class="col-lg-9 col-md-7 col-sm-12 bg d-none d-md-flex"
        :style="{ backgroundImage: 'url(' + require('@/assets/login-bg.jpg') + ')' }"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-8 offset-sm-2 left-panel">
              <img src="../../../assets/UNODC-logo-full.png" class="img-responsive tablet-logo desktop-logo" />
              <div class="news-card mt-4">
                <h3 class="news-card-heading">Department's Focal Point Login</h3>
                <div class="news-content">
                  <H3 class="focal-subheading">Register Event Nominees with UNODC's Event</h3>
                  <p class="focal-copy">
                    Get your department's nominees registered for the event using the
                    credentials shared by your organizer.
                  </p>
                  <p class="focal-copy">
                    This login is reserved for department focal points and gives access
                    to participant registration only.
                  </p>
                  <p class="focal-copy"style="padding-top:40px;">
                    <h4>Enter the event code and event password provided by the Programme Officer.</h4>
                  </p>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Login form section -->
      <div class="col-lg-3 col-md-5 col-sm-12 bg-blue">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 text-center login-form-container">
              <h6 class="text-white text-uppercase mb-4">login</h6>
              <div class="alert alert-danger" v-if="error">{{ error }}</div>
              <form action="#" @submit.prevent="handleLogin">
                <div class="form-group">
                  <label class="sr-only" for="eventCode">Event Code</label>
                  <div class="input-pill">
                    <span class="input-icon" aria-hidden="true">&#128100;</span>
                    <input
                      ref="codeInput"
                      type="text"
                      v-model="trainingCode"
                      class="form-control login-input"
                      placeholder="Event Code"
                      id="eventCode"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="sr-only" for="eventPassword">Event Password</label>
                  <div class="input-pill">
                    <span class="input-icon" aria-hidden="true">&#128274;</span>
                    <input
                      v-model="trainingToken"
                      type="password"
                      class="form-control login-input"
                      placeholder="Event Password"
                      id="eventPassword"
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  class="btn btn-black btn-login mt-3 btn-sm"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="login-footer">
      M&E Unit - United Nations Office on Drugs and Crime - COPAK
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      trainingCode: "",
      trainingToken: "",
      error: "",
      basepath: process.env.VUE_APP_BASE_PATH,
    };
  },
  mounted() {
    if (this.$refs.codeInput) {
      this.$refs.codeInput.focus();
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material",
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    async handleLogin() {
      try {
        this.openLoading();
        const response = await axios.post(
          this.basepath + "/training/is-training-exist",
          {
            training_code: this.trainingCode,
            training_token: this.trainingToken,
          }
        );

        if (response.data) {
          sessionStorage.setItem("trainingInfo", JSON.stringify(response.data));
          this.$router.push("/addParticipants");
        }
      } catch (error) {
        this.error =
          error.response?.data?.message || "An error occurred during login";
      } finally {
        this.closeLoading();
      }
    },
  },
};
</script>

<style scoped>
body,
html {
  height: 100% !important;
  overflow: hidden;
  margin: 0;
}

.login-shell {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.bg {
  display: inline-flex;
  /* Full height */
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-blue {
  /* The image used */
  background-color: #00a6e4;
  float: right;
  /* Full height */
  height: 100%;
}

.btn-black {
  background-color: #354146 !important;
  color: #fff !important;
}

::placeholder {
  color: #cdcdcd !important;
  text-align: left;
}

.login-container {
  flex: 1;
  margin: 0;
  min-height: 0;
  overflow: hidden;
}

.mobile-logo {
  background-color: #00a6e4;
  padding: 20px 0;
}

.mobile-logo-img {
  max-width: 280px;
  margin: 0 auto;
}

.login-form-container {
  margin-top: 30px;
}

.desktop-logo {
  max-width: 360px;
  margin-bottom: -1.25rem;
}

/* Make left panel fill its column cleanly */
@media (min-width: 768px) {
  .left-panel {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100%;
    margin-top: 0;
    gap: 0;
  }
}

/* CLEANED-UP NEWS CARD */
.news-card {
  margin-top: 0.75rem;
  width: 120%;
  max-width: 120%;
  height: 366px;
  transform: translateX(-10%);
  background: rgba(255, 255, 255, 0.85);
  border-radius: 18px;
  box-shadow: 0 30px 45px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  padding: 1.1rem 1.4rem;
  box-sizing: border-box;
  overflow: hidden;
}

/* Heading stays at top, list scrolls if needed */
.news-card-heading {
  font-size: 0.95rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  color: #0b1a2a;
  flex-shrink: 0;
}

/* Fixed-height content area, no scrollbars */
.news-content {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  padding-top: 10px;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
}
.news-content::-webkit-scrollbar {
  width: 0;
}

.news-content:hover {
  scrollbar-width: thin;
  scrollbar-color: #0073c1 transparent;
}
.news-content:hover::-webkit-scrollbar {
  width: 6px;
}
.news-content:hover::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
}
.news-content:hover::-webkit-scrollbar-thumb {
  background: #0073c1;
  border-radius: 3px;
}

/* Stacked list of stories */
.focal-subheading {
  color: #0b1a2a;
  font-size: 1.15rem;
  margin: 0 0 0.75rem;
  font-weight: 700;
}

.focal-copy {
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  color: #243547;
  line-height: 1.45;
}

.login-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f2f2f2;
  color: #0056a3;
  text-align: center;
  padding: 0.5rem;
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  z-index: 10;
}

@media (min-width: 768px) {
  .login-form-container {
    margin-top: 110px;
  }
}

/* Adjust form inputs for better mobile experience */
.form-control {
  max-width: 100%;
  margin: 0;
}

.input-pill {
  position: relative;
  max-width: 320px;
  margin: 0 auto;
}

.input-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  pointer-events: none;
}

.login-input {
  border-radius: 25px;
  padding: 12px 16px 12px 42px;
  height: auto;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 0.95rem;
  text-align: left;
}

.login-input:focus {
  border-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

/* Adjust button for mobile */
.btn-black {
  width: auto;
  margin: 0;
}

.btn-login {
  padding: 6px 64px;
  border-radius: 25px;
  letter-spacing: 0.08em;
  box-shadow: 0 12px 18px rgba(0, 0, 0, 0.25);
}

/* Tablet-specific styles */
@media (min-width: 768px) and (max-width: 1024px) {
  .tablet-logo {
    width: 340px !important;
    max-width: 100%;
  }

  .tablet-title {
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .login-form-container {
    margin-top: 80px;
  }

  .form-control {
    max-width: 240px;
  }

  .btn-black {
    width: 160px;
    font-size: 0.9rem;
  }
}

/* Update existing responsive styles */
.login-form-container {
  margin-top: 30px;
}

@media (min-width: 1025px) {
  .login-form-container {
    margin-top: 110px;
  }
}

/* Adjust the existing logo styles */
.tablet-logo {
  width: 460px;
  max-width: 100%;
}

@media (min-width: 992px) {
  .input-pill {
    max-width: 360px;
  }

  .login-input {
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: none;
    padding: 12px 16px 12px 40px;
    letter-spacing: 0.02em;
  }

  .input-icon {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    left: 12px;
  }
}
</style>
